
import { NgModule } from '@angular/core';

import { TransferEditProvider } from './transfer-edit.provider';
import { TransferListProvider } from './transfer-list.provider';

export * from './transfer-edit.provider';
export * from './transfer-list.provider';

export {
  TransferListProvider,
  TransferEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    TransferEditProvider,
    TransferListProvider
  ]
})
export class TransferBackendModule { }
